import { useState } from "react";
import { SingleCardImageSkeleton } from "./SingleCardSkeleton";

export const SingleCardImage = ({ src, alt, style }) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  return (
    <>
      {isImageLoading && <SingleCardImageSkeleton />}
      <img
        src={src}
        alt={alt}
        onLoad={() => {
          setIsImageLoading(false);
        }}
        style={{ display: isImageLoading ? "none" : "block", ...style }}
      />
    </>
  );
};
